/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('taxpayerCtrl', taxpayerCtrl)
        .controller('newTaxpayerCtrl', newTaxpayerCtrl)
        .controller('editTaxpayerCtrl', editTaxpayerCtrl)
        .controller('deleteTaxpayerController', deleteTaxpayerController);

    taxpayerCtrl.$inject = ['taxpayers','linkService'];
    newTaxpayerCtrl.$inject = ['taxpayerService'];
    editTaxpayerCtrl.$inject = ['taxpayerService','linkService','taxpayer'];
    deleteTaxpayerController.$inject = ['taxpayerService', '$uibModalInstance', '$stateParams'];

    function taxpayerCtrl(taxpayers,linkService) {
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];
        vm.taxpayers = (taxpayers.data._embedded) ? taxpayers.data._embedded.taxpayers : [];
        vm.pages = taxpayers.data.page;
    }

    function newTaxpayerCtrl(taxpayerService) {
        var vm = this;
        vm.isDisabled = false;
        vm.saveTaxpayer = function(isValid, taxpayerForm){
            if(isValid){
                taxpayerService.saveTaxpayer(taxpayerForm);
            }
        }
    }

    function editTaxpayerCtrl(taxpayerService, linkService, taxpayer) {
        var vm = this;
        vm.taxpayer = taxpayer.data;
        vm.taxpayer.nit = parseInt(taxpayer.data.nit);
        vm.isDisabled = true;

        vm.saveTaxpayer = function(isValid, taxpayerForm){
            if(isValid){
                taxpayerService.updateTaxpayer(taxpayerForm,linkService.getLinkId(taxpayerForm._links.self.href));
            }
        }
    }

    function deleteTaxpayerController(taxpayerService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.deleteTaxpayer = function(){
            taxpayerService.deleteTaxpayer($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
